import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeadphones = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.45699 14.8382C3.75333 14.3724 4.18164 13.9828 4.7191 13.7322C5.72014 13.2654 6.91004 13.6985 7.37683 14.6995L9.06738 18.3249C9.53417 19.326 9.10108 20.5159 8.10005 20.9827C6.5985 21.6829 4.81365 21.0332 4.11347 19.5317L3.26811 17.7188C2.81855 16.7547 2.92544 15.6738 3.45699 14.8382ZM3.45699 14.8382C3.16072 13.946 3.00031 12.9917 3.00031 12C3.00031 7.02944 7.02975 3 12.0003 3C16.9709 3 21.0003 7.02944 21.0003 12C21.0003 13.026 20.8286 14.012 20.5124 14.9307M20.5124 14.9307C20.2152 14.424 19.7664 13.9992 19.1938 13.7322C18.1928 13.2654 17.0029 13.6985 16.5361 14.6995L14.8455 18.3249C14.3787 19.326 14.8118 20.5159 15.8129 20.9827C17.3144 21.6829 19.0993 21.0332 19.7994 19.5317L20.6448 17.7188C21.078 16.7899 20.9945 15.7525 20.5124 14.9307ZM17.5629 4.92407L16.0011 6.99937C14.9714 6.38709 13.2767 5.99994 12.0021 5.99994C10.7018 5.99994 9.04536 6.36461 8.00207 6.99994L6.43604 4.92593",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})
});
export default SvgHeadphones;
